document.addEventListener('DOMContentLoaded', function() {
    // forms() já é inicializado globalmente em main.js — não chamar de novo aqui,
    // ou o submit do form roda duas vezes (envio duplicado).

    // Get the form
    const form = document.querySelector('.needs-validation');

    // Phone mask handler
    const phoneInput = document.querySelector('#phone');
    if (phoneInput) {
        phoneInput.addEventListener('input', function(e) {
            let value = e.target.value.replace(/\D/g, '');
            if (value.length > 11) {
                value = value.slice(0, 11);
            }

            // Format the phone number
            if (value.length > 0) {
                value = '+' + value;
                if (value.length > 3) {
                    value = value.slice(0, 3) + ' (' + value.slice(3);
                }
                if (value.length > 7) {
                    value = value.slice(0, 7) + ') ' + value.slice(7);
                }
                if (value.length > 13) {
                    value = value.slice(0, 13) + '.' + value.slice(13);
                }
            }

            e.target.value = value;
        });
    }

    // Form validation
    form.addEventListener('submit', function(event) {
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }

        form.classList.add('was-validated');
    });
});
